import ViewBase from "../view-base.view";
import { POSMGoodsHierachy } from "./posm-goods-hierachy";
import goodMovementModel from "../../models/posm/goods-movement.model";
import { Spinner } from "construct-ui";
import { formats } from "../../config/constants";
import moment from "moment";
import DatePickerComponent from "../../components/date-picker/date-picker.component";
import DisplayAllGoodmaster from "./display-all-goodmaster.view";
import { ASCENDING_TEXT, DESCENDING_TEXT } from "../../models/posm/posm.constant";
export default function POSMGoodMasterView() {
  ViewBase.call(this);
  let isHierachyLoading = false;
  let currentInputGoodTypeOrder = 0;
  const DEFAULT_PAGINATION = {
    pageSize: 10,
    pageIndex: 1
  }
  const DEFAULT_FILTERS = {
    DateFrom: moment().subtract(1, 'M').startOf('M').format(formats.apiDateFormat),
    DateTo: moment().format(formats.apiDateFormat),
  };
  let listGoodMovement = [];
  const inputDataModel = structuredClone(DEFAULT_FILTERS);
  const CATEGORY_ORDER = {
    MAIN: 0,
    GOODS_TYPE: 1,
    DIVISION: 2,
    MODEL: 3,
    BASIC_MODEL: 4,
  };
  let MOVEMENT_OPTIONS = {
    main: [],
    goodsType: [],
    division: [],
    model: [],
    basicModel: [],
  };
  let totalListGoodMovement = 0;
  let movementDetail = structuredClone({
    main: { code: "", name: null, id: "" },
    goodsType: { code: "", name: null, id: "" },
    division: { code: "", name: null, id: "" },
    model: { code: "", name: null, id: "" },
    basicModel: { code: "", name: null, id: "" },
  });
  let hierachyLabels = [];
  let paginationObj = structuredClone(DEFAULT_PAGINATION);
  let currentFilter = {};
  const setPaginationObj = (paginationPatch) => {
    paginationObj = { ...DEFAULT_PAGINATION, ...paginationPatch }
  }
  const resetPagination = () => {
    paginationObj = { ...DEFAULT_PAGINATION };
  }
  const getCurrentFilters = () => {
    currentFilter = {
      ...paginationObj, ...inputDataModel,
      GoodsTypeId: movementDetail.goodsType.id,
      DivisionId: movementDetail.division.id,
      ModelId: movementDetail.model.id,
      BasicModelId: movementDetail.basicModel.id
    }
  }
  const onDownLoadGoodMaster = () => {
    goodMovementModel.downloadGoodMaster({ ...currentFilter, sortBy: sortObj.sortBy ? `[${sortObj.sortBy}]` : '', orderBy: sortObj.orderBy })
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => {
        this.hideLoading();
      })
  }
  const onSearchForGoodMasterList = () => {
    this.showLoading();
    getCurrentFilters();
    goodMovementModel.getGoodMasterList({ ...currentFilter, sortBy: sortObj.sortBy ? `[${sortObj.sortBy}]` : '', orderBy: sortObj.orderBy }).then((data) => {
      totalListGoodMovement = data.total;
      listGoodMovement = data.data;
    }).catch((err) => {
      this.handleError(err);
    })
      .finally(() => {
        this.hideLoading()
      })
  }
  const getFirstLevelOptions = () => {
    goodMovementModel
      .getHierachyTreeByLevel(1, 1)
      .then((data) => {
        MOVEMENT_OPTIONS.main =
          goodMovementModel.createHierachyOptions(data);
        isHierachyLoading = false;
      })
      .catch((err) => {
        isHierachyLoading = false;
        handleError(err);
      });
  }
  const resetMovementDetailGoodtype = (inputGoodTypeOrder) => {
    let currentIndex = 0;
    for (const prop in movementDetail) {
      if (currentIndex <= CATEGORY_ORDER.BASIC_MODEL) {
        if (currentIndex > inputGoodTypeOrder) {
          movementDetail[prop] = { code: null, name: null };
          MOVEMENT_OPTIONS[prop] = []
        }
      }

      currentIndex++;
    }
  };
  const onSelect = (s, categoryName, categoryOrderName, categoryOrderChildName, categoryChildName) => {
    const oldCode = movementDetail[categoryName]?.code
    movementDetail[categoryName] = s;
    if (s.code) {
      if (s.code != oldCode) {
        currentInputGoodTypeOrder = CATEGORY_ORDER[categoryOrderChildName];
        resetMovementDetailGoodtype(
          currentInputGoodTypeOrder
        );
        if (categoryOrderChildName) {
          isHierachyLoading = true;
          goodMovementModel
            .getHierachyTreeByParentCode(s.id)
            .then((data) => {
              MOVEMENT_OPTIONS[categoryChildName] =
                goodMovementModel.createHierachyOptions(
                  data
                );
              isHierachyLoading = false;
            })
            .catch((err) => {
              isHierachyLoading = false;
              handleError(err);
            });
          movementDetail[categoryChildName] = { code: null, name: null, id: null };
        }
      }
    } else {
      currentInputGoodTypeOrder = CATEGORY_ORDER[categoryOrderName];
      movementDetail[categoryName] = {
        name: null,
        code: null,
        id: null
      };

      resetMovementDetailGoodtype(
        CATEGORY_ORDER[categoryOrderName]
      );
    }
  }

  let sortObj = {
    sortBy: '',
    orderBy: '',
  }

  const _flipOrderText = (orderText) => {
    return orderText.toUpperCase() === DESCENDING_TEXT ? ASCENDING_TEXT : DESCENDING_TEXT
  }

  const onSortClick = (sortBy) => {
    if (sortObj.sortBy === sortBy) {
      sortObj.orderBy = _flipOrderText(sortObj.orderBy)
    } else {
      sortObj.sortBy = sortBy;
      sortObj.orderBy = DESCENDING_TEXT;
    }
    onSearchForGoodMasterList();
  }

  return {
    oninit: (vnode) => {
      hierachyLabels = goodMovementModel.taiwanHierachyLabel;
      getFirstLevelOptions();
    },
    view: () => {
      return [
        isHierachyLoading &&
        m(Spinner, { fill: true, background: true, active: true }),
        m('.card.mb-3',
          m('.card-body',
            m('.position-relative',
              m('.row.row-cols-5.g-2.mb-2',
                m(POSMGoodsHierachy, { MOVEMENT_OPTIONS, movementDetail, hierachyLabels, onSelect, CATEGORY_ORDER, currentInputGoodTypeOrder }),),
              m('.row.g-2.mt-2',
                m('.col-md-3.col-lg-3.position-relative',
                  m('label.form-label', this.getText('LT00001281', 'Receive Date')),
                  m('.input-group',
                    m(DatePickerComponent, {
                      class: 'form-control',
                      isRange: true,
                      readonly: true,
                      grid: 1,
                      calendars: 1,
                      date: formats.dateFormat,
                      dateStart: inputDataModel.DateFrom && moment(inputDataModel.DateFrom).format(formats.dateFormat),
                      dateEnd: inputDataModel.DateTo && moment(inputDataModel.DateTo).format(formats.dateFormat),
                      required: true,
                      onselect: (e) => {
                        inputDataModel.DateFrom = moment(e.detail.start).format(formats.apiDateFormat);
                        inputDataModel.DateTo = moment(e.detail.end).format(formats.apiDateFormat);

                      }
                    })
                  )
                )
              ),
              m('.d-flex.col-12.justify-content-end',
                m('button.btn.btn-primary',
                  {
                    onclick: () => {
                      onSearchForGoodMasterList();
                    },
                  },
                  this.getText('LT00000001', 'Search')
                )
              )
            )
          )
        ),
        m(DisplayAllGoodmaster, {
          listGoodMovement,
          onSearchForGoodMasterList,
          resetPagination,
          setPaginationObj,
          totalItems: totalListGoodMovement,
          onDownLoadGoodMaster,
          sortObj,
          onSortClick,
        }),

        this.getBaseViews(),
      ]
    }
  }
}